'use strict';

const callWebService = require('*/capency/email/serverActions/callWebService');
var capAddressConfig = [];
var urlCapEmailConfig = $('#url-cap-email-config').val();
const base = require('capencyBase/capency/email/function');
const invalidFeedback = require('capency/capency/utils/invalidFeedback');


/**
 * Create an alert to display the error message
 * @param {string} message - Error message to display
 */
function createErrorNotification(message) {
    const errorHtml = '<div class="alert alert-danger alert-dismissible valid-cart-error '
        + 'fade show" role="alert">'
        + '<button type="button" class="close" data-dismiss="alert" aria-label="Close">'
        + '<span aria-hidden="true">&times;</span>'
        + '</button>' + message + '</div>';

    $('.error-messaging').append(errorHtml);
}

/// Call Ajax for get All configuration
$.ajax({
    url: urlCapEmailConfig,
    type: 'get',
    async: false,
    dataType: 'json',
    success: function (data) {
        var capConfiguration = data.result;
        capAddressConfig = capConfiguration.length > 0 ? JSON.parse(capConfiguration) : [];
    },
    error: function (err) { }
});


/**
* Handles the email data source for a given form configuration, including validation and autocomplete setup.
*
* @param {Object} configCurrentForm - Configuration object for the current form.
* @param {string} configCurrentForm.idForm - The ID of the form element.
* @param {boolean} configCurrentForm.formChild - Flag indicating if the email selector is a child of the form.
* @param {string} configCurrentForm.EmailID - The ID of the email input element.
* @param {string} configCurrentForm.firstName - The ID of the first name input element.
* @param {string} configCurrentForm.lastName - The ID of the last name input element.
*/
function dataSourceEmail(configCurrentForm) {
    var $formID = $('#' + configCurrentForm.idForm);
    let $emailSelector = configCurrentForm.formChild ? $formID.find('#' + configCurrentForm.EmailID) : $('#' + configCurrentForm.EmailID);
    var $firstNameSelector = $('#' + configCurrentForm.firstName);
    var $lastNameSelector = $('#' + configCurrentForm.lastName);

    var email = $emailSelector.val();
    var fname = $firstNameSelector.val();
    var lname = $lastNameSelector.val();
    let $invalidFeedback = invalidFeedback.getInvalidFeedbackElement($emailSelector);
    const errorAlert = $('.error-messaging')

    callWebService.SearchMailCivWS(email, fname, lname).then(function (searchResulat) {
        errorAlert.empty();
        if (searchResulat.returnCode && searchResulat.returnCode === 1) {
            if (invalidFeedback.length) {
                $invalidFeedback.empty().html(searchResulat.sMessage).show();
            } else {
                createErrorNotification(searchResulat.sMessage);
            }
            $emailSelector.addClass('is-invalid');
            $formID.find(':submit').prop('disabled', true);
            if ($('.ui-autocomplete').length) {
                $emailSelector.autocomplete('destroy');
            }
        } else {
            $emailSelector.removeClass('is-invalid');
            $formID.find(':submit').prop('disabled', false);
            var finalDatasource = $.map(searchResulat.mail, function (item) {
                return {
                    label: item.sMail,
                    value: item.sMail
                };
            });

            if (finalDatasource.length > 0) {
                    $emailSelector.autocomplete({
                        create: function () {
                            $(this).attr('autocomplete', 'off');
                        },
                        minLength: 0,
                        autoFocus: true,
                        source: function (request, response) {
                            response(finalDatasource);
                        },
                        select: function (event, ui) {
                            let $this = $(this);
                            $this.next().html(ui.item.sMail);
                            $this.toggleClass('autocomplete-field-selected', true);
                            $invalidFeedback.empty();
                            $this.data('isModified', true);
                        }
                    }).focus(function () {
                        return false;
                    });
                $emailSelector.autocomplete('search', '');
            } else if ($emailSelector.autocomplete('instance')) {
                $emailSelector.autocomplete('destroy');
            }
        }
    });
}

/**
* Initiates the email processing flow based on the provided form configuration.
* If the form configuration contains an 'EmailID' property, it triggers the dataSourceEmail function.
*
* @param {Object} currentFormConfig - The current form configuration object.
* @property {string} currentFormConfig.EmailID - The email ID to be processed.
*/
function callProcessEmailFlow(currentFormConfig) {
    if (currentFormConfig.hasOwnProperty('EmailID')) {
        dataSourceEmail(currentFormConfig);
    }
}

base.callProcessEmailFlow = callProcessEmailFlow;
module.exports = base;
